'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1Extra1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Extra1, _Component);

  function Module1Extra1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Extra1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Extra1.__proto__ || (0, _getPrototypeOf2.default)(Module1Extra1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'What is a serve of grains, meat, dairy?'
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = {};
      obj.isCompleted = true;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1Extra1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h3',
            null,
            'What is a serve of grains?'
          ),
          _react2.default.createElement(_components.GrainServe, null),
          _react2.default.createElement(_components.FoodTable, { foodtitle: 'grains', foodtype: 'Grain foods', twoyear: '4', fouryearboy: '4', fouryeargirl: '4',
            nineyearboy: '5', nineyeargirl: '4', twelveyearboy: '6', twelveyeargirl: '5' }),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'h3',
            null,
            'What is a serve of meat and alternatives?'
          ),
          _react2.default.createElement(_components.MeatServe, null),
          _react2.default.createElement(_components.FoodTable, { foodtitle: 'meat', foodtype: 'Lean meats, poultry, fish, eggs, tofu, nuts, seeds', twoyear: '1',
            fouryearboy: '1 1/2', fouryeargirl: '1 1/2', nineyearboy: '2 1/2', nineyeargirl: '2 1/2', twelveyearboy: '2 1/2',
            twelveyeargirl: '2 1/2' }),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'h3',
            null,
            'What is a serve of dairy and alternatives?'
          ),
          _react2.default.createElement(_components.DairyServe, null),
          _react2.default.createElement(_components.FoodTable, { foodtitle: 'dairy products', foodtype: 'Dairy', twoyear: '1 1/2', fouryearboy: '2', fouryeargirl: '1 1/2',
            nineyearboy: '2 1/2', nineyeargirl: '3', twelveyearboy: '3 1/2', twelveyeargirl: '3 1/2' }),
          _react2.default.createElement('div', { className: styles.spacer20 })
        )
      );
    }
  }]);
  return Module1Extra1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Extra1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Extra/Extra1.js
// module id = 1174
// module chunks = 0